import React from 'react';
import styles from './InfoPill.styles';

export default function InfoPill({ text, color, fontSize, backgroundColor}) {
  return <div style={{ backgroundColor, fontSize, color, ...styles.container }}>{text}</div>;
}
